import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
interface SubscriptionCardProps {
  selected: boolean;
  onSelect: () => void;
  title: string;
  discount?: string;
  benefits: string[];
  discountPercent?: string;
}
export function SubscriptionCard({
  selected,
  onSelect,
  title,
  discount,
  benefits,
  discountPercent
}: SubscriptionCardProps) {
  return <button onClick={onSelect} className={`
        w-full text-left p-5 rounded-xl border-2 transition-all
        ${selected ? 'border-[#496f58] bg-[#496f58]/5' : 'border-gray-200 hover:border-gray-300'}
      `} data-id="element-465">
      <div className="flex items-start gap-3" data-id="element-466">
        <div className={`
          w-5 h-5 rounded-full border-2 flex items-center justify-center mt-0.5 flex-shrink-0
          ${selected ? 'border-[#496f58] bg-white' : 'border-gray-300 bg-white'}
        `} data-id="element-467">
          {selected && <div className="w-3 h-3 rounded-full bg-[#496f58]" data-id="element-468"></div>}
        </div>

        <div className="flex-1" data-id="element-469">
          <div className="flex items-center gap-2 mb-3" data-id="element-470">
            <span className="font-bold text-gray-900 text-base" data-id="element-471">
              {title}{' '}
              {discountPercent && <span className="text-[#496f58]" data-id="element-472">{discountPercent}</span>}
            </span>
          </div>

          {benefits.length > 0 && <>
              <div className="text-xs text-gray-500 uppercase tracking-wide font-semibold mb-2.5" data-id="element-473">
                How Membership Works:
              </div>
              <div className="space-y-2" data-id="element-474">
                {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-2.5 text-sm text-gray-700" data-id="element-475">
                    <CheckCircleIcon className="w-4 h-4 text-[#496f58] mt-0.5 flex-shrink-0" data-id="element-476" />
                    <span data-id="element-477">{benefit}</span>
                  </div>)}
              </div>
            </>}
        </div>
      </div>
    </button>;
}